var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",class:_vm.isRtl ? 'rtl' : 'ltr',attrs:{"id":"app","dir":_vm.isRtl ? 'rtl' : 'ltr'}},[(_vm.isReady)?_c('router-view'):(_vm.isNotInIframe)?_c('div'):_c('div',[_c('Loading',{staticClass:"h-[244px]"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }